<script setup>
import { computed } from 'vue';
import { Handle, Position, useNode } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const CONTEXT_LABELS = computed(() => ({
  contact: t('FLOW_BUILDER.NODES.SET_CONTEXT.CONTACT'),
  conversation: t('FLOW_BUILDER.NODES.SET_CONTEXT.CONVERSATION'),
}));
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-orange-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-orange-500 text-white">
      <span class="i-lucide-focus size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.SET_CONTEXT.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      <span v-if="data.context_type && data.variable">
        {{ `${CONTEXT_LABELS[data.context_type] ?? data.context_type} ← ` }}<span class="font-mono text-n-slate-10">{{ data.variable }}</span>
      </span>
      <span v-else class="text-n-slate-9">{{ t('FLOW_BUILDER.NODES.SET_CONTEXT.NO_CONTEXT') }}</span>
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
